module.exports = __webpack_public_path__ + "img/drag_indicator_black_24dp.b6d28000.svg";